<template>
  <div class="feedback">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'InvalidFeedback'
}
</script>

<style scoped>
.feedback {
  display: block;
  width: 100%;
  margin-top: .25rem;
  font-size: 80%;
  color: #dc3545;
}
</style>
